import { useEffect } from 'react'

import { getStore } from '@/store'

import { markContentTouched } from '../../generatorState'
import { GENERATOR_SEARCH_PARAM } from '../../generatorTypes'
import { useGeneratorSearchParam } from '../../hooks'
import { TQrContentAtom } from '../../utils/qrTypeToContentAtom'

export const useDisableDemoModeOnTouch = (contentAtom: TQrContentAtom) => {
	const qrId = useGeneratorSearchParam(GENERATOR_SEARCH_PARAM.Id)

	useEffect(() => {
		if (!qrId && contentAtom) {
			const unsubscribe = getStore().sub(contentAtom, () => {
				markContentTouched()
				unsubscribe()
			})
			return unsubscribe
		}
	}, [contentAtom, qrId])
}
